import React, { FunctionComponent, useState } from "react";
import { Control, DeepMap, FieldError } from "react-hook-form";
import { FormDropdown, mapToDropdownOption } from "sprint-common-web";

import { CourseOfActionReference } from "../../../common/types/CourseOfActionReference";
import { CourseOfActionFormInputs } from "./CourseOfActionFormInputs";

export interface CourseOfActionFormFieldsProps {
    control: Control;
    errors: DeepMap<CourseOfActionFormInputs, FieldError>;
    courseOfActions: CourseOfActionReference[];
    fixedBillings: CourseOfActionReference[];
}

export const CourseOfActionFormFields: FunctionComponent<CourseOfActionFormFieldsProps> = ({
    control,
    errors,
    courseOfActions,
    fixedBillings
}: CourseOfActionFormFieldsProps) => {
    const [isFixedBillingEnabled, setIsFixedBillingEnabled] = useState<boolean>(false);

    const handleCourseOfActionChange = (value: string) => {
        setIsFixedBillingEnabled(shouldFixedBillingBeEnabled(value, courseOfActions));
    };

    return (
        <>
            <FormDropdown
                name="courseOfActionId"
                label="Course of action"
                disabled={courseOfActions.length === 0}
                options={courseOfActions.map((action) => mapToDropdownOption(action))}
                rules={{ required: "Select a course of action" }}
                control={control}
                errors={errors}
                onChange={handleCourseOfActionChange}
            />
            {isFixedBillingEnabled && (
                <FormDropdown
                    name="fixedBillingId"
                    label="Fixed billing"
                    disabled={fixedBillings.length === 0}
                    options={fixedBillings.map((billing) => mapToDropdownOption(billing))}
                    control={control}
                    errors={errors}
                />
            )}
        </>
    );
};

const shouldFixedBillingBeEnabled = (
    selectedCourseOfActionId: string,
    courseOfActions: CourseOfActionReference[]
): boolean => {
    const foundCourseOfAction = courseOfActions.find((action) => action.id === selectedCourseOfActionId);

    return foundCourseOfAction?.name === "Can be fixed in-house at cost";
};
